define('default-ui',[], function() {

  var app = angular.module('default.ui', []);

  app.service('$defaultUI', [function() {
    return function() {


    }; // End return
  }]); // End angular.service();
}); // End define();

